import { connect } from "react-redux";

import EnergieBilanz from "./EnergieBilanz";

import { chartsSetDataSourceAction } from "../model/Diagramme";
import { requestEnergyBalanceOfHeDataLogFiles } from "../model/util/HeDataLogFiles";

export default connect(state => ({
	today: new Date(state.rtc),
	compressors: state.ablauf.compressors,
	settings: state.settings,
	units: state.units,
	auth: state.user,
	ablauf_version: state.ablauf.master.version,
	dataSource: state.charts.data_source_index,
	sortedListOfHeDataLogFiles: state.he_data_log_files.sortedListOfAvailableDays
}), dispatch => ({
	setDataSource: (dataSourceIndex) => {
		dispatch(chartsSetDataSourceAction(dataSourceIndex))
	},
	requestEnergyBalanceHeDataLogFiles: (purpose, requiredData, sortedListOfHeDataLogFiles) => {
		requestEnergyBalanceOfHeDataLogFiles(purpose, requiredData, sortedListOfHeDataLogFiles, dispatch);
	},
})
)(EnergieBilanz);
